import React, { useState } from "react";
import "./App.css";

function App() {
  const [agent, setAgent] = useState("tan");
  const [message, setMessage] = useState("");
  const [response, setResponse] = useState("");
  const [loading, setLoading] = useState(false);

  const agents = [
    "dolphinmini","dolphings","dolphinplus",
    "han","kinggs","seal","shark",
    "songplus","songpluspremium","songprogs",
    "tan","yuanplus","yuanpro"
  ];

 const sendMessage = async () => {
  if (!message.trim()) return;
  setLoading(true);
  try {
    const apiUrl = process.env.REACT_APP_API_URL || "http://127.0.0.1:8000";
const res = await fetch(`${apiUrl}/chat`, {
  method: "POST",
  headers: { "Content-Type": "application/json" },
  body: JSON.stringify({ agent, message }),
});
    const data = await res.json();
    console.log("API response:", res.status, data);              // << debug
    if (!res.ok) {
      // pega o detalhe do erro que o FastAPI mandou
      throw new Error(data.detail || "Erro genérico na API");
    }
    setResponse(data.response);
  } catch (err) {
    console.error(err);
    setResponse(`❌ ${err.message}`);
  }
  setLoading(false);
};

  return (
    <>
      <header className="site-header">
        <div className="container header-inner">
          <div className="logo">Veículos Eletrificados</div>
          <div className="contact-info">
            Whatsapp: (43) 99682-6978 - Rafael Figueiredo
          </div>
        </div>
      </header>

      <section className="hero">
        <div className="container">
          <h1>Agente de Vendas BYD</h1>
          <p>Seu assistente virtual para conhecer toda a linha de carros elétricos BYD.</p>
        </div>
      </section>

      <main className="container main-content">
        <div className="chat-card">
          <div className="chat-card-header">
            Escolha seu modelo
          </div>
          <div className="form-group">
            <select
              value={agent}
              onChange={e => setAgent(e.target.value)}
              disabled={loading}
            >
              {agents.map(a=>(
                <option key={a} value={a}>{a.toUpperCase()}</option>
              ))}
            </select>
          </div>
          <div className="form-group">
            <input
              type="text"
              placeholder="Faça sua pergunta..."
              value={message}
              onChange={e=>setMessage(e.target.value)}
              onKeyDown={e=>e.key==="Enter"&&sendMessage()}
              disabled={loading}
            />
          </div>
          <button onClick={sendMessage} disabled={loading}>
            {loading ? "Carregando..." : "Enviar"}
          </button>
          <div className="response-box">
            {typeof response === "string"
  ? response.split("\n").map((line, i) => <p key={i}>{line}</p>)
  : null}
          </div>
        </div>
      </main>

      <footer className="site-footer">
        <div className="container">
          © {new Date().getFullYear()} Veículos Eletrificados
        </div>
      </footer>
    </>
  );
}

export default App;
